import type { DrawNumber } from '../../../../schema/draw/entry.js';
import type { Definition } from '../../../../schema/frameworks/entry.js';
import type { WagerId } from '../../../../schema/wager/entry.js';
import { AuthorizationError, type IAuthorizedUseCase, type IExamineWagerUseCase } from '../../../domain/entry.js';

export type IExamineWagerController = ReturnType<typeof examineWagerController>;

/**
 * Controller to examine a wager.
 *
 * @param examineWagerUseCase Use case for examining a wager
 * @param authorizedUseCase Use case to check user role
 * @returns Controller function that examines wager data
 */
export function examineWagerController(
  examineWagerUseCase: IExamineWagerUseCase,
  authorizedUseCase: IAuthorizedUseCase
) {
  return async function controller(
    wagerId: WagerId,
    product: Definition['drawProducts'][number],
    drawNumber: DrawNumber
  ): Promise<void> {
    const isAuthorized = await authorizedUseCase.execute({ role: 'Player' });
    if (!isAuthorized) {
      throw new AuthorizationError('User not authorized to examine wager');
    }

    await examineWagerUseCase.execute({ wagerId, product, drawNumber });
  };
}
